// Immediate answer to a tap on the build map. The route point itself only appears after the 200 ms
// double-click window (`_addKeyPointDebounce`), then the routing round trip: until then the map looked
// like it had not registered the tap.
//
// Purely visual: nothing here adds, removes or reroutes a point.

export const TAP_FEEDBACK_DURATION = 600;

// The states in which BuildMap._addKeyPointAtClickLoc (buildMap.js) will NOT add a route point for this
// click. A pure read: that function resets markerEventClicked / hasPopup itself. Keep both lists in step.
export const isMapClickAddingPoint = (model = {}, mapModel = {}) => !(
    model.poiModeEnabled ||
    model.waypointModeEnabled ||
    model.freehandDraw ||
    model.sectionColorMode ||
    model.retraceMode ||
    model.hasPopup ||
    model.isComputingRoad ||
    mapModel.markerEventClicked
);

// Returns a function that removes the feedback early (a double click zooms, it adds no point).
export const showTapFeedback = (map, lngLat, buildMarker) => {
    const marker = buildMarker('tap-feedback', lngLat, {markerContent: '<span class="tap-feedback-ring"></span>'});
    if (!marker) {
        return () => {};
    }

    marker.getElement().setAttribute('aria-hidden', 'true');
    marker.addTo(map);

    const timer = setTimeout(() => marker.remove(), TAP_FEEDBACK_DURATION);

    return () => {
        clearTimeout(timer);
        marker.remove();
    };
};
